import { render } from "./AuthorityTable.vue?vue&type=template&id=5831a6be&scoped=true"
import script from "./AuthorityTable.vue?vue&type=script&lang=ts"
export * from "./AuthorityTable.vue?vue&type=script&lang=ts"

import "./AuthorityTable.vue?vue&type=style&index=0&id=5831a6be&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5831a6be"

export default script